<template>
  <div class="wrapper">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      class="steps-content m-flex1"
    >
      <a-row :gutter="16">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-model-item label="No SPPD/S" prop="id_sppd">
            <a-select
              showSearch
              placeholder="Please select"
              :disabled="isFormEdited"
              @change="handleNoSppd"
              :filter-option="filterByNoSppd"
              v-model="form.id_sppd"
            >
              <a-select-option v-for="item in umList" :key="item.id_sppd">
                {{ item.no_sppd }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Date" prop="tgl_buat">
            <a-input v-model="form.tgl_buat" :disabled="true"></a-input>
          </a-form-model-item>
          <!-- <a-form-model-item label="End User" prop="end_user">
            <a-select
              showSearch
              placeholder="Please select"
              v-model="form.end_user"
            >
              <a-select-option
                v-for="karyawan in getAllKaryawan"
                :key="karyawan.tlc"
                >{{ karyawan.tlc }} - {{ karyawan.nama }}</a-select-option
              >
            </a-select>
          </a-form-model-item> -->
          <a-form-model-item label="Description" prop="deskripsi">
            <a-input v-model="form.deskripsi"
            ></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <!-- <div style="display:none">
          <a-form-model-item label="Vice President Finance Approval" prop="bod">
            <a-input disabled v-model="form.bod"></a-input>
          </a-form-model-item>
          </div> -->
          <!-- <a-form-model-item label="Note" prop="catatan">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-model="form.catatan"
            />
          </a-form-model-item> -->
          <a-form-model-item label="Currency" prop="mata_uang">
            <a-select
              showSearch
              :disabled="isFormEdited && detail.length !== 0"
              @change="handleMataUang"
              v-model="form.mata_uang"
            >
              <a-select-option
                v-for="item in getAllMataUang"
                :key="item.code"
                :value="item.code"
                >{{ item.code }} - {{ item.currency }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="kurs">
            <span slot="label"
              >Exchange Rate 1,00 {{ form.mata_uang }} to IDR</span
            >
            <a-input-number
              :min="1"
              :disabled="isFormEdited && detail.length !== 0"
              type="number"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="form.kurs"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "information",
  props: {
    data: {},
    detail: {},
    mode: "",
  },
  data() {
    return {
      umList: [],
      form: {
        id_sppd: undefined,
        tgl_buat: moment().format("DD-MM-YYYY"),
        end_user: "",
        mata_uang: "",
        kurs: undefined,
        estimate_value: "",
        atasan_langsung: "",
        bod: "",
        deskripsi: "",
      },
      rules: {
        id_sppd: [
          {
            required: true,
            message: "Please Select SPPD",
            trigger: "change",
          },
        ],
        end_user: [
          {
            required: true,
            message: "Please Select End User",
            trigger: "change",
          },
        ],
        mata_uang: [
          {
            required: true,
            message: "Please Select Currency",
            trigger: "change",
          },
        ],
        tgl_buat: [{ required: true }],
        kurs: [{ required: true, message: "Please Input Exchange Rate" }],
        bod: [{ required: true, trigger: "blur" }],
        deskripsi: [{ required: true, trigger: "change" }],
      },
      mataUang: {
        kurs: 1,
        estimate_value: 0,
        mata_uang: "IDR",
      },
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
    this.$store
      .dispatch("getListSppd", { data: this.getAuth })
      .then((res) => {
        this.umList = res.data;
      })
      .catch((err) => {
        this.displayMessage("no-active-sppd");
        this.$router.go(-1);
      });
    this.fetchMataUang();
  },
  watch: {
    data() {
      if (Object.entries(this.data).length !== 0) {
        this.form = this.data;
      }
    },
  },
  mounted() {
    if (Object.entries(this.data).length !== 0) {
      this.form = this.data;
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getAllMataUang",
      "getAllKaryawan",
      "getDefaultDateFormat",
    ]),
    isFormEdited() {
      if (this.mode == "Edit") {
        return true;
      } else {
        if (this.detail == undefined || this.detail.length == 0) {
          return false;
        }
      }

      return true;
    },
    initialData() {
      if (this.mode == "Create") {
        return {
          deskripsi: "",
          end_user: "",
        };
      }
    },
  },
  methods: {
    moment,
    handleRef() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        }

        Event.$emit("handleChildValue", this.form);
      });
    },
    handleMataUang(kurs) {
      this.mataUang.mata_uang = kurs;
      if (kurs == "IDR") {
        this.form.kurs = 1;
      } else {
        this.form.kurs = 1;
      }
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    fetchMataUang() {
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
    },
    handleNoSppd(item) {
      let filter = this.umList.filter(
        (obj) => obj.id_sppd.toLowerCase().indexOf(item.toLowerCase()) >= 0
      );

      this.form.bod = filter[0].bod + " - " + filter[0].nama_bod;
      this.form.no_sppd = filter[0].no_sppd;

      Event.$emit("downPayment", filter[0].seq);
    },
    filterByNoSppd(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: @padding;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
